import * as Yup from 'yup';
import { INVALID_FIELDS, serialPatternRegex, YupString } from './general';

export const createCycleSchemas = Yup.object().shape({
  ciDate: YupString,
  cycleId: YupString,
  // Required, and must be XXXX-XXXX-XXXX (same rule as order kit serials)
  serial: YupString.matches(serialPatternRegex, {
    message: INVALID_FIELDS.WRONG_FORMAT,
    excludeEmptyString: true,
  }),
  screeningTypes: Yup.array().of(
    Yup.object().shape({
      type: YupString,
      status: YupString,
      testResult: Yup.object(),
    }),
  ),
});
